// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-view {
	display: block;
	color: #4d4d4d;
	text-align: left;
	--json-property: #009033;
	--json-index: #676dff;
	--json-number: #676dff;
	--json-string: #b2762e;
	--json-boolean: #dc155e;
	--json-null: #dc155e;
}
.json-view .json-view--property {
	color: var(--json-property);
}
.json-view .json-view--index {
	color: var(--json-index);
}
.json-view .json-view--number {
	color: var(--json-number);
}
.json-view .json-view--string {
	color: var(--json-string);
}
.json-view .json-view--boolean {
	color: var(--json-boolean);
}
.json-view .json-view--null {
	color: var(--json-null);
}

.json-view .jv-indent {
	padding-left: 1em;
}
.json-view .jv-chevron {
	display: inline-block;
	vertical-align: -20%;
	cursor: pointer;
	opacity: 0.4;
	width: 1em;
	height: 1em;
}
:is(.json-view .jv-chevron:hover, .json-view .jv-size:hover + .jv-chevron) {
	opacity: 0.8;
}
.json-view .jv-size {
	cursor: pointer;
	opacity: 0.4;
	font-size: 0.875em;
	font-style: italic;
	margin-left: 0.5em;
	vertical-align: -5%;
	line-height: 1;
}

.json-view :is(.json-view--copy, .json-view--edit),
.json-view .json-view--link svg {
	display: none;
	width: 1em;
	height: 1em;
	margin-left: 0.25em;
	cursor: pointer;
}

.json-view .json-view--input {
	width: 120px;
	margin-left: 0.25em;
	border-radius: 4px;
	border: 1px solid currentColor;
	padding: 0px 4px;
	font-size: 87.5%;
	line-height: 1.25;
	background: transparent;
}
.json-view .json-view--deleting {
	outline: 1px solid #da0000;
	background-color: #da000011;
	text-decoration-line: line-through;
}

:is(.json-view:hover, .json-view--pair:hover) > :is(.json-view--copy, .json-view--edit),
:is(.json-view:hover, .json-view--pair:hover) > .json-view--link svg {
	display: inline-block;
}

.json-view .jv-button {
	background: transparent;
	outline: none;
	border: none;
	cursor: pointer;
	color: inherit;
}
.json-view .cursor-pointer {
	cursor: pointer;
}

.json-view svg {
	vertical-align: -10%;
}
.jv-size-chevron ~ svg {
	vertical-align: -16%;
}

/* Themes */
.json-view_a11y {
	color: #545454;
	--json-property: #aa5d00;
	--json-index: #007299;
	--json-number: #007299;
	--json-string: #008000;
	--json-boolean: #d91e18;
	--json-null: #d91e18;
}
.json-view_github {
	color: #005cc5;
	--json-property: #005cc5;
	--json-index: #005cc5;
	--json-number: #005cc5;
	--json-string: #032f62;
	--json-boolean: #005cc5;
	--json-null: #005cc5;
}
.json-view_vscode {
	color: #005cc5;
	--json-property: #0451a5;
	--json-index: #0000ff;
	--json-number: #0000ff;
	--json-string: #a31515;
	--json-boolean: #0000ff;
	--json-null: #0000ff;
}
.json-view_atom {
	color: #383a42;
	--json-property: #e45649;
	--json-index: #986801;
	--json-number: #986801;
	--json-string: #50a14f;
	--json-boolean: #0184bc;
	--json-null: #0184bc;
}
.json-view_winter-is-coming {
	color: #0431fa;
	--json-property: #3a9685;
	--json-index: #ae408b;
	--json-number: #ae408b;
	--json-string: #8123a9;
	--json-boolean: #0184bc;
	--json-null: #0184bc;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/react18-json-view/src/style.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,wBAAwB;AACzB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,eAAe;CACf,YAAY;CACZ,UAAU;CACV,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;AACf;;AAEA;;CAEC,aAAa;CACb,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,8BAA8B;CAC9B,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,uBAAuB;AACxB;AACA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,kCAAkC;AACnC;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;CACvB,aAAa;CACb,YAAY;CACZ,eAAe;CACf,cAAc;AACf;AACA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;;AAEA,WAAW;AACX;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,wBAAwB;CACxB,qBAAqB;CACrB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,oBAAoB;AACrB","sourcesContent":[".json-view {\r\n\tdisplay: block;\r\n\tcolor: #4d4d4d;\r\n\ttext-align: left;\r\n\t--json-property: #009033;\r\n\t--json-index: #676dff;\r\n\t--json-number: #676dff;\r\n\t--json-string: #b2762e;\r\n\t--json-boolean: #dc155e;\r\n\t--json-null: #dc155e;\r\n}\r\n.json-view .json-view--property {\r\n\tcolor: var(--json-property);\r\n}\r\n.json-view .json-view--index {\r\n\tcolor: var(--json-index);\r\n}\r\n.json-view .json-view--number {\r\n\tcolor: var(--json-number);\r\n}\r\n.json-view .json-view--string {\r\n\tcolor: var(--json-string);\r\n}\r\n.json-view .json-view--boolean {\r\n\tcolor: var(--json-boolean);\r\n}\r\n.json-view .json-view--null {\r\n\tcolor: var(--json-null);\r\n}\r\n\r\n.json-view .jv-indent {\r\n\tpadding-left: 1em;\r\n}\r\n.json-view .jv-chevron {\r\n\tdisplay: inline-block;\r\n\tvertical-align: -20%;\r\n\tcursor: pointer;\r\n\topacity: 0.4;\r\n\twidth: 1em;\r\n\theight: 1em;\r\n}\r\n:is(.json-view .jv-chevron:hover, .json-view .jv-size:hover + .jv-chevron) {\r\n\topacity: 0.8;\r\n}\r\n.json-view .jv-size {\r\n\tcursor: pointer;\r\n\topacity: 0.4;\r\n\tfont-size: 0.875em;\r\n\tfont-style: italic;\r\n\tmargin-left: 0.5em;\r\n\tvertical-align: -5%;\r\n\tline-height: 1;\r\n}\r\n\r\n.json-view :is(.json-view--copy, .json-view--edit),\r\n.json-view .json-view--link svg {\r\n\tdisplay: none;\r\n\twidth: 1em;\r\n\theight: 1em;\r\n\tmargin-left: 0.25em;\r\n\tcursor: pointer;\r\n}\r\n\r\n.json-view .json-view--input {\r\n\twidth: 120px;\r\n\tmargin-left: 0.25em;\r\n\tborder-radius: 4px;\r\n\tborder: 1px solid currentColor;\r\n\tpadding: 0px 4px;\r\n\tfont-size: 87.5%;\r\n\tline-height: 1.25;\r\n\tbackground: transparent;\r\n}\r\n.json-view .json-view--deleting {\r\n\toutline: 1px solid #da0000;\r\n\tbackground-color: #da000011;\r\n\ttext-decoration-line: line-through;\r\n}\r\n\r\n:is(.json-view:hover, .json-view--pair:hover) > :is(.json-view--copy, .json-view--edit),\r\n:is(.json-view:hover, .json-view--pair:hover) > .json-view--link svg {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.json-view .jv-button {\r\n\tbackground: transparent;\r\n\toutline: none;\r\n\tborder: none;\r\n\tcursor: pointer;\r\n\tcolor: inherit;\r\n}\r\n.json-view .cursor-pointer {\r\n\tcursor: pointer;\r\n}\r\n\r\n.json-view svg {\r\n\tvertical-align: -10%;\r\n}\r\n.jv-size-chevron ~ svg {\r\n\tvertical-align: -16%;\r\n}\r\n\r\n/* Themes */\r\n.json-view_a11y {\r\n\tcolor: #545454;\r\n\t--json-property: #aa5d00;\r\n\t--json-index: #007299;\r\n\t--json-number: #007299;\r\n\t--json-string: #008000;\r\n\t--json-boolean: #d91e18;\r\n\t--json-null: #d91e18;\r\n}\r\n.json-view_github {\r\n\tcolor: #005cc5;\r\n\t--json-property: #005cc5;\r\n\t--json-index: #005cc5;\r\n\t--json-number: #005cc5;\r\n\t--json-string: #032f62;\r\n\t--json-boolean: #005cc5;\r\n\t--json-null: #005cc5;\r\n}\r\n.json-view_vscode {\r\n\tcolor: #005cc5;\r\n\t--json-property: #0451a5;\r\n\t--json-index: #0000ff;\r\n\t--json-number: #0000ff;\r\n\t--json-string: #a31515;\r\n\t--json-boolean: #0000ff;\r\n\t--json-null: #0000ff;\r\n}\r\n.json-view_atom {\r\n\tcolor: #383a42;\r\n\t--json-property: #e45649;\r\n\t--json-index: #986801;\r\n\t--json-number: #986801;\r\n\t--json-string: #50a14f;\r\n\t--json-boolean: #0184bc;\r\n\t--json-null: #0184bc;\r\n}\r\n.json-view_winter-is-coming {\r\n\tcolor: #0431fa;\r\n\t--json-property: #3a9685;\r\n\t--json-index: #ae408b;\r\n\t--json-number: #ae408b;\r\n\t--json-string: #8123a9;\r\n\t--json-boolean: #0184bc;\r\n\t--json-null: #0184bc;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
